import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LinksModel, Link } from 'ng-voxloud/lib/links-summary/links-summary.model';

@Component({
  selector: 'gdp-links-popup',
  templateUrl: './links-popup.component.html',
  styleUrls: ['./links-popup.component.scss']
})
export class LinksPopupComponent implements OnInit {
  @Input() links: LinksModel;
  @Input() title: string = 'company.user.links-popup.title';
  @Input() message: string = 'company.user.links-popup.message';
  public lang: string;

  constructor(
    private modal: NgbActiveModal,
    private translationService: TranslateService
  ) {}

  ngOnInit(): void {
    this.lang = this.translationService.currentLang;
    for (let l of Object.keys(this.links)) {
      this.links[l] = this.links[l].map((el: Link) => ({ ...el, readonly: true }));
    }
  }

  close() {
    this.modal.close();
  }
}